import { Component, forwardRef, Input, OnInit } from '@angular/core'
import { ConfigurationOptionSelectAdvancedComponent } from '../configuration-option-select-advanced/configuration-option-select-advanced.component'
import { LocaleService } from '../../../../../../framework/locale/services/locale.service'
import { FormControl, NG_ASYNC_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
import { SelectableDealOption } from 'modules/deals/utilities/deal-types'
import { isFsdGrowthModelValue } from 'modules/deals/utilities/fsd-helpers'

interface AutopilotSelectableValues {
    autopilot: SelectableDealOption['selectedValue']
    fsd: SelectableDealOption['selectedValue']
    growthModel: SelectableDealOption['selectedValue']
}

@UntilDestroy()
@Component({
    selector: 'mg-configuration-option-select-advanced-fsd',
    templateUrl: './configuration-option-select-advanced-fsd.component.html',
    styleUrls: ['./configuration-option-select-advanced-fsd.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ConfigurationOptionSelectAdvancedFsdComponent),
            multi: true,
        },
        {
            provide: NG_ASYNC_VALIDATORS,
            useExisting: forwardRef(() => ConfigurationOptionSelectAdvancedFsdComponent),
            multi: true,
        },
    ],
})
export class ConfigurationOptionSelectAdvancedFsdComponent
    extends ConfigurationOptionSelectAdvancedComponent
    implements OnInit
{
    fsdFormControl: FormControl
    growthModelFormControl: FormControl
    assignedSelectableValues: AutopilotSelectableValues

    @Input() dealId: string

    get fsdFormControlValue() {
        return this.fsdFormControl.value
    }

    constructor(public localeService: LocaleService) {
        super(localeService)
    }

    ngOnInit() {
        const { selectedValue, selectableValues } = this.configurationOption as SelectableDealOption

        this.assignedSelectableValues = selectableValues.reduce(
            (values, value) => {
                if (value.labelId.trim().endsWith('autopilot')) {
                    values.autopilot = value
                } else if (isFsdGrowthModelValue(value)) {
                    values.growthModel = value
                } else if (value.labelId.trim().includes('full_self_driving')) {
                    values.fsd = value
                }

                return values
            },
            { autopilot: undefined, growthModel: undefined, fsd: undefined }
        )

        this.fsdFormControl = new FormControl(!selectedValue.labelId.trim().endsWith('autopilot'))
        this.growthModelFormControl = new FormControl(selectedValue.labelId.trim().endsWith('model'))

        this.fsdFormControl.valueChanges.pipe(untilDestroyed(this)).subscribe(isFsdSelected => {
            if (!isFsdSelected) {
                this.growthModelFormControl.setValue(false, { emitEvent: false })
            }

            const selectedValueId = isFsdSelected
                ? this.assignedSelectableValues.fsd.id
                : this.assignedSelectableValues.autopilot.id

            this.componentFormControl.setValue(selectedValueId)
        })

        this.growthModelFormControl.valueChanges.pipe(untilDestroyed(this)).subscribe(isGrowthModelSelected => {
            const selectedValueId = isGrowthModelSelected
                ? this.assignedSelectableValues.growthModel.id
                : this.assignedSelectableValues.fsd.id

            this.componentFormControl.setValue(selectedValueId)
        })
    }
}
